export default {
  currentLocation: null,
  reportedLocations: null
}



// WEBPACK FOOTER //
// ./src/store/locations/state.js